import React from 'react';
import useIsIOS from './useIsIOS';
import InstallPWA from './InstallPWA'

const InstallIosPrompt = ({portal}) => {
    const isIOSData = useIsIOS(portal);
    return (
        <>
            {isIOSData != null && isIOSData.isIOS  == true && isIOSData.isSafari  == true && isIOSData.prompt  == true  ? (
            <InstallPWA />
            ) : ''}
        </>
    );
};
export default InstallIosPrompt;
